import { camelizeKeys } from 'humps'
import { WretcherError } from 'wretch'

interface ApiResponse {
  readonly status: number
  readonly body: object

  isError: boolean
  errors: object
}

/**
 * The ApiSuccess and ApiError classes have the same external API once they've
 * been instantiated. This is helps once they are received by a component, as
 * the component can then decide what to do based on status or error
 */
class ApiSuccess implements ApiResponse {
  readonly status: number
  readonly body: object
  private readonly authorizationHeader?: string | null

  constructor(response: object, authorizationHeader?: string | null) {
    this.status = 200
    this.body = camelizeKeys(response)
    this.authorizationHeader = authorizationHeader
  }

  get token(): string | null | undefined {
    if (this.authorizationHeader) {
      return this.authorizationHeader.replace('Bearer ', '')
    }
    return this.authorizationHeader
  }

  get isError() {
    return false
  }

  get errors() {
    return {}
  }
}

class ApiError implements ApiResponse {
  readonly status: number
  body: object

  constructor(response: WretcherError | Response, jsonBody?: any) {
    this.status = response.status
    let parsedBody
    if (jsonBody) {
      parsedBody = jsonBody
    } else if (typeof response.text === 'string') {
      parsedBody = JSON.parse(response.text || '{}')
    }

    this.body = camelizeKeys(parsedBody?.errors ?? parsedBody?.error ?? parsedBody)
  }

  get isError() {
    return true
  }

  get errors() {
    return this.body
  }
}

export { ApiError, ApiSuccess }
